import React from 'react'

import Section from '../Section/index'
import { IframeSectionProps } from './types'
import Iframe from './../../molecules/Iframe'

const IframeSection: React.FC<IframeSectionProps> = ({
  id,
  heading,
  isHeadingGreen,
  isMainHeading,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data
}) => (
  <Section
    {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, isMainHeading, subheading, description }}
    body={<Iframe {...{ data }} />}
  />
)

export default IframeSection
